export default __webpack_public_path__ + "static/media/mini-loader.8c2bc854.svg";